/**
 * Distance calculation using the haversine formula
 * @param start - { lat, lon } of the origin point
 * @param end - { lat, lon } of the destination point
 * @returns distance in kilometers
 */
export function computeWithHaversine(
  start: { lat: number; lon: number },
  end: { lat: number; lon: number },
): number {
  const startLat = degToRad(start.lat);
  const startLon = degToRad(start.lon);
  const endLat = degToRad(end.lat);
  const endLon = degToRad(end.lon);

  const earthRadiusKm = 6371;

  // Haversine formula
  const distance =
    Math.acos(
      Math.sin(startLat) * Math.sin(endLat) +
        Math.cos(startLat) * Math.cos(endLat) * Math.cos(startLon - endLon),
    ) * earthRadiusKm;

  return Math.round(distance);
}

function degToRad(deg: number): number {
  const rad = (deg * Math.PI) / 180;
  return rad;
}
